<template>
  <v-card class="pa-2" outlined tile height="100%">
    <SignDialog
      ref="signDialog"
      @updateHABSigned="updateHABSigned"
      @updateSignature="updateSignature"
      :updatedSignature="updatedSignature"
    />

    <v-snackbar v-model="msg" top :vertical="true">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark :color="color" text v-bind="attrs" @click="msg = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-data-table
      v-bind="tableProps"
      :headers="headers"
      sort-by="Date"
      sort-desc
      :loading="isLoading"
      :search="search"
      :items-per-page="10"
      height="475"
      ref="table"
    >
      <template v-slot:group.header="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length">
          <v-btn @click="toggle" x-small icon :ref="group">
            <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
          <span class="font-weight-bold">{{ group }}</span>
        </td>
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{isPageHistory ? 'Completed HAB' : 'Unsigned HAB'}}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
          ></v-text-field>
          <v-spacer></v-spacer>

          <!-- dialog -->
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2 hidden-sm-and-down" @click="viewHABSigned(item)">
          mdi-eye
        </v-icon>

        <v-btn
          outlined
          medium
          class="mr-2 hidden-sm-and-up"
          color="light-blue darken-4"
          @click="viewHABSigned(item)"
        >
          edit
        </v-btn>

        <v-icon
          v-if="admin && isPageHistory"
          class="mr-2 hidden-sm-and-down"
          small
          @click="deleteHABSigned(item)"
        >
          mdi-delete
        </v-icon>

        <v-btn
          outlined
          medium
          v-if="admin && isPageHistory"
          class="ml-2 hidden-sm-and-up red--text"
          @click="deleteHABSigned(item)"
        >
          delete
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getHABSigned()">Reset</v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from "axios";
import { setUserTz, setUserSignatureTz } from "../../../../utils/timezone";
import {  mapActions, mapGetters, mapMutations } from "vuex";
import SignDialog from "./SignDialog";
import moment from "moment";

const url = require("@/client_config/config").url;

export default {
  props: {
    isPageHistory: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    SignDialog
  },
  data() {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "Date",
        },
        { text: "HAB Plan Step", value: "StepDescription" },
        { text: "Assistance", value: "Assistance" },
        { text: "Notes", value: "Notes" },
        { text: "Signature", value: "Signature" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      clientID: null,
      search: "",
      dialog: false,
      requiredRules: [],
      editADL: false,
      habSigned: [],
      isLoading: true,
      itemData: {},
      msg: false,
      color: "",
      text: "",
      updatedSignature: "",
      admin: false,
    };
  },

  created() {
    if (
      localStorage.getItem("userRole") == "Administration" ||
      localStorage.getItem("userRole") == "Program Coordinator" ||
      localStorage.getItem("userRole") == "Compliance Manager" ||
      localStorage.getItem("userRole") == "Client Services Manager" ||
      localStorage.getItem("userRole") == "Human Resources" ||
      localStorage.getItem("userRole") == "Medical Manager"
    ) {
      this.admin = true;
    }
    this.clientID = this.$route.params.clientID;
    this.getHABSigned();
    this.getUnsignedHAB();
  },

  computed: {
    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
      getHABUnsigned: "hab/getHABUnsigned",
    }),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    userSignatureTz() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserSignatureTz(data);
    },

    tableProps() {  
      if (this.isPageHistory)
        return {
          items: this.habSigned,
          groupBy: "Date",
          groupDesc: "group-desc",
          loadingText: "Loading HAB Plan History",
        };  
      return {
        items: this.getHABUnsigned,
        loadingText: "Loading Unsigned",
      };
    },
  },

  methods: {
    ...mapActions({
      getUnsigned: "hab/fetchHABUnsigned",
    }),
    ...mapMutations({
      setDialog: "services/SET_DIALOG",
    }),
    getHABSigned() {
      this.habSigned = [];
      this.isLoading = true;
      axios
        .get(`${url}/hab/signed/client/${this.clientID}`)
        .then((res) => {
          console.log(res);
          (this.habSigned = []), (this.tempData = res.data.hab);
          for (var i = 0; i < this.tempData.length; i++) {
            // convert date base on user timezone
            this.tempData[i].Date = moment(this.tempData[i].Date).format(
              "YYYY-MM-DD"
            );
            if(this.tempData[i].Signature !== ""){
              this.habSigned.push(this.tempData[i]);
            }
          }
        })
        .finally(() => ((this.isLoading = false), this.defaultToggleState()));
    },

    deleteHABSigned(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this HAB Plan?") &&
        this.onDeleteHABSigned(id);
    },

    updateHABSigned(data, id) {
      const req_body = {
        ...data,
      };
      axios.put(`${url}/hab/signed/${id}`, req_body).then((response) => {
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.getHABSigned();
        this.newDate = "";
        this.newAssistance = "";
        this.newNotes = "";
        this.newSignature = "";
        this.msg = true;
        this.text = "The HAB Plan has been updated successfully.";
        this.close();
      });
    },

    onDeleteHABSigned(id) {
      axios
        .delete(`${url}/hab/signed/${id}`)
        .then((response) => {
          if (response.status == 400) {
            response.json().then(function(data) {
              return data.msg;
            });
          }
          this.msg = true;
          this.text = "The HAB Plan has been deleted successfully.";
          this.getHABSigned();
        });
    },

    async getUnsignedHAB() {
      const data = {
        id: this.clientID,
        userTimezone: this.userTimezone,
      };

      let test = await this.getUnsigned(data);
      console.log(test);
    },

    viewHABSigned(item) {
      this.$refs.signDialog.onViewItem(item);
      this.setDialog(true);
    },

    updateSignature() {
      this.updatedSignature =
        localStorage.getItem("Name") + " - " + this.userSignatureTz;
    },

    defaultToggleState() {
      let table = this.$refs.table;
      let keys = Object.keys(table.$vnode.componentInstance.openCache);
      keys.forEach((x) => {
        table.$vnode.componentInstance.openCache[x] = false;
      });
    },

    close() {
      this.setDialog(false);
    },
  },
};
</script>
